(() => {
  const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

  function enhance() {
    if (prefersReducedMotion || !('IntersectionObserver' in window)) return;

    const nodes = document.querySelectorAll(
      '#MainContent .search-discovery a, #MainContent .exotica-trust [data-ex-reveal], #MainContent .exotica-clearance__content, #MainContent .exotica-clearance__media'
    );

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('ex-is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.07, rootMargin: '0px 0px -6% 0px' });

    nodes.forEach((element, index) => {
      if (element.dataset.exRevealInit) return;
      element.dataset.exRevealInit = '1';
      element.classList.add('ex-reveal');
      element.style.setProperty('--ex-delay', `${Math.min(index % 6, 5) * 35}ms`);
      observer.observe(element);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance, { once: true });
  } else {
    enhance();
  }

  document.addEventListener('shopify:section:load', enhance);
})();
